<script>
  import Feature from "./Feature.svelte";
  import ContractInfo from "./ContractInfo.svelte";
  export let info, tip;

  let last = info.last_drawing + 144;

  $: wait = last - tip;
</script>

<ContractInfo {info} />
<section>
  <Feature
    img="images/lotto.svg"
    text={`Para participar basta escolher um número entre 0 e 4096. Qualquer pessoa pode iniciar o sorteio, 1 vez a cada 144 blocos (~1 dia). ${
      wait > 0 ? `Próximo sorteio em ${wait} blocos.` : ""
    }`}
  />
  <Feature
    img="images/lottery.svg"
    text="Se ninguém ganhar, o prémio fica acumulado para o próximo sorteio e nunca perdes os teus bilhetes"
  />
  <Feature
    img="images/wheel.svg"
    text="O número vencedor é obtido pelos 3 últimos caractéres do hash do bloco imediatamente a seguir ao último bilhete comprado, revertido e convertido para decimal"
  />
</section>

<style>
  section {
    width: 100%;
    display: block;
    padding-top: 4rem;
    padding-bottom: 2.5rem;
  }

  @media (min-width: 640px) {
    section {
      display: flex;
      flex: 1 1 auto;
      justify-content: space-evenly;
    }
  }
</style>
